import { render } from "./Header.vue?vue&type=template&id=063e5ad0&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=063e5ad0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-063e5ad0"

export default script